/**
 * `useHoverIntent` mutual-exclusion group for the desktop navbar.
 *
 * Every menu on the nav row passes this, so opening one closes whichever was open —
 * `ProductsDropdown`, `BrandsDropdown` (both click-open) and the Promotions
 * `HoverNavMenu` (hover-open).
 *
 * Deliberately **not** shared with `ProductMenuDropdown`: product-card menus are
 * per-card and don't compete for the nav row's space. (`CartIndicator` has no hover
 * panel at all — its click opens the cart drawer.)
 */
export const NAV_MENU_GROUP = "desktop-nav";

/**
 * Shape of every item on the desktop nav row: radius, inset margin, padding, hover fill
 * and focus ring. Callers add their own colour and weight.
 */
export const NAV_ITEM_CLASS =
  "my-[6px] inline-flex items-center gap-[6px] whitespace-nowrap rounded-md px-[14px] py-[8px] font-sans text-sm [transition:background_var(--duration-fast),color_var(--duration-fast)] hover:bg-soft focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]";

export const PROMOTION_NAV_ITEMS = [
  { label: "Promotions", path: "/promotions", icon: "sell" },
  {
    label: "JDIQ Raffle Winners",
    path: "/promotions/jdiq",
    icon: "emoji_events",
  },
  {
    label: "Monthly Specials",
    path: "/promotions/monthly-special",
    icon: "calendar_month",
  },
  {
    label: "DND Gift Card Program",
    path: "/promotions/gift-card",
    icon: "card_giftcard",
  },
  // Folded in from its old top-level navbar slot (on request) — deals-adjacent,
  // so it lives with the other offers.
  { label: "Clearance", path: "/clearance", icon: "percent" },
];

// The old "About Us" navbar menu (About / Meet Our Team / FAQs / Contact / Blog)
// was removed from the nav on request; those destinations live in the Footer's
// "We're here" column now.
